import { useState } from 'react';
import { socials } from '@/components/icons/social';

/**
 * The social icon row.
 *
 * Icons sit neutral at rest so the row reads as one set, then take their
 * platform's own brand colour on hover. Colour is applied via inline style
 * rather than a class because the values come from data, and hover state is
 * tracked in JS so it never latches on touch devices.
 */
export function SocialLinks({ onDark = false }: { onDark?: boolean }) {
  const [hovered, setHovered] = useState<string | null>(null);

  const idle = onDark ? 'border-white/15 text-white/70' : 'border-hairline text-ink/70';

  return (
    <ul className="flex flex-wrap gap-3">
      {socials.map(({ name, href, color, colorOnDark, Icon }) => {
        const active = hovered === name;
        const brand = onDark ? (colorOnDark ?? color) : color;
        return (
          <li key={name}>
            <a
              href={href}
              target="_blank"
              rel="noreferrer noopener"
              aria-label={`Falcon Solutions on ${name}`}
              onMouseEnter={() => setHovered(name)}
              onMouseLeave={() => setHovered(null)}
              onFocus={() => setHovered(name)}
              onBlur={() => setHovered(null)}
              className={`grid h-11 w-11 place-items-center rounded-full border transition-colors duration-300 ${idle}`}
              style={
                active
                  ? {
                      color: brand,
                      borderColor: brand,
                      backgroundColor: onDark ? 'rgb(255 255 255 / 0.06)' : `${brand}12`,
                    }
                  : undefined
              }
            >
              <Icon />
            </a>
          </li>
        );
      })}
    </ul>
  );
}
